/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WebAuthnGetChallengeAllOf
 */
export interface WebAuthnGetChallengeAllOf {
    /**
     * The "Options for Assertion Generation" as described by the WebAuthn spec at https://www.w3.org/TR/webauthn/#assertion-options
     * @type {object}
     * @memberof WebAuthnGetChallengeAllOf
     */
    options?: object;
}

/**
 * Check if a given object implements the WebAuthnGetChallengeAllOf interface.
 */
export function instanceOfWebAuthnGetChallengeAllOf(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebAuthnGetChallengeAllOfFromJSON(json: any): WebAuthnGetChallengeAllOf {
    return WebAuthnGetChallengeAllOfFromJSONTyped(json, false);
}

export function WebAuthnGetChallengeAllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebAuthnGetChallengeAllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'options': !exists(json, 'options') ? undefined : json['options'],
    };
}

export function WebAuthnGetChallengeAllOfToJSON(value?: WebAuthnGetChallengeAllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'options': value.options,
    };
}

